var searchOpen = false;
var $searchDropdownSection = $(".header__search");
var $searchDropdownForm = $(".header__search form");
var $searchDropdownSectionOverlay = $(".header__search-overlay");
var $searchDropdown = $(".header__search-dropdown");
var $searchResults = $("#search-results");
var $searchClear = $("#search-clear");
var $searchLoader = $("#search-loader");
var $formInput = $("#search-input");
var $formInputText = $("#search-input-text");
var debounceTimer;
var searchRequestId = 0;

const debounce = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        callback.apply(null, args);
      }, wait);
    };
}  

function focusAndOpenKeyboard(el, timeout) {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if(!timeout) {
      timeout = 100;
    }
    if(el) {
      // Align temp input element approximately where the input element is
      // so the cursor doesn't jump around
      var __tempEl__ = document.createElement('input');
      __tempEl__.style.position = 'absolute';
      if(!isMobile){
          __tempEl__.style.display = "none";
      }
      __tempEl__.style.top = (el.offsetTop + 7) + 'px';
      __tempEl__.style.left = el.offsetLeft + 'px';
      __tempEl__.style.height = 0;
      __tempEl__.style.opacity = 0;
      // Put this temp element as a child of the page <body> and focus on it
      document.getElementById("shopify-section-search-dropdown").prepend(__tempEl__);
      __tempEl__.focus();
  
      // The keyboard is open. Now do a delayed focus on the target element
      setTimeout(function() {
        el.focus();
        el.click();
        // Remove the temp element
        document.getElementById("shopify-section-search-dropdown").removeChild(__tempEl__);
      }, timeout);
    }
  }

function toggleSearchDropdown () {
    searchOpen = !searchOpen;
    if(searchOpen){
        $("body").addClass("search-open")
        $searchDropdownSection.addClass("header__search--active")
        $searchDropdownSectionOverlay.addClass("header__search-overlay--active")
        focusAndOpenKeyboard($formInput, 300)

    } else {
        searchRequestId++;
        $("body").removeClass("search-open")
        $searchResults.addClass("search-results--active");
        $searchDropdownSection.removeClass("header__search--active")
        $searchDropdownSectionOverlay.removeClass("header__search-overlay--active")
        setTimeout(() => {
            $searchResults.html("");
        }, 300);
    }    
}

$searchDropdownForm.on("submit", function(e) {
    e.preventDefault();
})

$("#search-toggle, #search-toggle-mobile").on("click", function(e){
    e.preventDefault();
    toggleSearchDropdown()
})

$searchDropdownSectionOverlay.on("click", function(){
    searchOpen = false;
    searchRequestId++;
    $("body").removeClass("search-open")
    $searchDropdownSection.removeClass("header__search--active")
    $searchDropdownSectionOverlay.removeClass("header__search-overlay--active")
})

$searchClear.on("click", function(e){
    e.preventDefault();
    searchOpen = false;
    searchRequestId++;
    $formInput.val("");
    $("body").removeClass("search-open")
    $searchDropdownSection.removeClass("header__search--active")
    $searchDropdownSectionOverlay.removeClass("header__search-overlay--active")
    setTimeout(() => {
        $searchResults.html("");
    }, 300);
})

$formInput.on("input change", function(e){
    $searchLoader.addClass("active");
    $formInputText.text(e.target.value.trim());
    $searchLoader.css("transform", `translateX(${($formInputText.width() * .5) + 20}px)`)
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
        let val = e.target.value.trim();
        $searchResults.removeClass("search-results--active");
        // $searchDropdown.removeClass("header__search-dropdown--has-no-results")
        // $searchDropdown.removeClass("header__search-dropdown--has-results")
        const requestId = ++searchRequestId;

        if(val.length > 0 || val !== ''){
            fetch(`${window.location.origin}/search?q=${encodeURIComponent(val)}&quick=true`).then(function (response) {
                return response.text();
            }).then(function (html) {
                // A newer search started while this one was in flight
                if (requestId !== searchRequestId) return;
                // Convert the HTML string into a document object
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, 'text/html');
                let prodsHTML = doc.getElementById("results").innerHTML;
                $searchLoader.removeClass("active");    
                $searchResults.html(prodsHTML);
                if(!doc.getElementById("results").querySelector(".shop-grid-item-v2")){
                    $searchDropdown.removeClass("header__search-dropdown--has-results")  
                    $searchDropdown.addClass("header__search-dropdown--has-no-results")
                    $searchResults.html(`<div class="text-center py-4"><p class="mb-0">Sorry! No results found.</p></div>`);
                } else {
                    $searchDropdown.removeClass("header__search-dropdown--has-no-results")  
                    $searchDropdown.addClass("header__search-dropdown--has-results")  
                }  
            }).catch(function () {
                if (requestId !== searchRequestId) return;
                $searchLoader.removeClass("active");
            })
        } else {
            setTimeout(() => {
                $searchDropdown.removeClass("header__search-dropdown--has-results")
                $searchDropdown.removeClass("header__search-dropdown--has-no-results")
                $searchResults.html("")
            }, 300);     
            $searchLoader.removeClass("active");    
        }    
    }, 150);
})